
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexGM7H6_olFXYctxxfT9ZnhZYkpelsURuhQkFgSlc8nBkMeta } from "/app/frontend/pages/index.vue?macro=true";
import { default as search0oNaZjBHxXQFC0T11KOZVsFVFrcH1qMYy1wrFVlFVcUMeta } from "/app/frontend/pages/search.vue?macro=true";
import { default as stylebook7RGbCcmoeUC2oFho_45B8PErB1e_45R_45YF97j9HscTALHaQMeta } from "/app/frontend/pages/stylebook.vue?macro=true";
import { default as indexmHuH5Riwp7lAI_PgbM9Ib0Nw_45skoGpqYfcTpVHhbO58Meta } from "/app/frontend/pages/login/index.vue?macro=true";
import { default as indexkxKXtqnkalYvLXZVSM7NDyjL7wQ9LXpyuPiOUHYEeqQMeta } from "/app/frontend/pages/testi/index.vue?macro=true";
import { default as indexNKyS0_45wHjeWUVyBJzM0kENbpVUWOcKC_45nNZ_Nl_1VtUMeta } from "/app/frontend/pages/video/index.vue?macro=true";
import { default as viedgramata6c96s90zohP_456EESZl4YGZR5Z_45zgW4iHslAqtqL_45bFYMeta } from "/app/frontend/pages/viedgramata.vue?macro=true";
import { default as mani_45zurnaliZcOnzrOsk6j96Qi8yccBqIVtXlgdhVc8VHfwFeFveFcMeta } from "/app/frontend/pages/mani-zurnali.vue?macro=true";
import { default as indexsrKX5jr5AcVehXbD_J0gFzDsbvweJ1FTEpp0uG1BLFcMeta } from "/app/frontend/pages/parskats/index.vue?macro=true";
import { default as indexeyUUJQL_GdMmnb3Xtg2OoStyw8F4uCASGURM1ZFSscYMeta } from "/app/frontend/pages/viedtemas/index.vue?macro=true";
import { default as indexCfZbKi68J1LUnTbw7eQy7gN0AIUq65iYCvAlU90vJY0Meta } from "/app/frontend/pages/e-gramatas/index.vue?macro=true";
import { default as indexT8x301uURxr0F778pM_45eBEoqnqW2sShAAUs_OXUy_MIMeta } from "/app/frontend/pages/mani-testi/index.vue?macro=true";
import { default as indexZoWxXVdKGnwzJV8N07rA_uqXt7MnZjEWOfkJIpdKjY4Meta } from "/app/frontend/pages/pirmsskola/index.vue?macro=true";
import { default as indexSPikpt1tLgR_45Dyb5ULfw1y3Xgsh6DFsdlkmiKSWZkpgMeta } from "/app/frontend/pages/darba-lapas/index.vue?macro=true";
import { default as index95uveVsjtNVo7o_Qcw2OCPo_3OYgMjUmIsTZhSkuc2YMeta } from "/app/frontend/pages/link/[code]/index.vue?macro=true";
import { default as _91slug_93MMC5KbSdXEUgMCBA6NLRlk1s8ma7otM0UHqNgzLzUK4Meta } from "/app/frontend/pages/pdf-reader/[slug].vue?macro=true";
import { default as indexFdAingsVbE4uJq6yf5Z7Dp6zj_mIw46OsRNEYo_yPKsMeta } from "/app/frontend/pages/somas-testi/index.vue?macro=true";
import { default as indexTIXKVbmMJNBxbXurYAJrX7Yn1XLzldlyt2God9aazXAMeta } from "/app/frontend/pages/visi-resursi/index.vue?macro=true";
import { default as parskatsvDWtul56GoSiNsnqI0AwcGibf4ki3MCuOmxuS_45CQVKEMeta } from "/app/frontend/pages/darba-lapas/parskats.vue?macro=true";
import { default as pdfT6RDHLLuxpV0O6ZyDT0IVxy_45iMCxyWAfsVvzAOLr1cwMeta } from "/app/frontend/pages/e-gramatas/[slug]/pdf.vue?macro=true";
import { default as index8OPjiJj2hspRk1mz3aN773KA24CyfRDrHTDwpC1bvDMMeta } from "/app/frontend/pages/jautajumu-banka/index.vue?macro=true";
import { default as indexvhaT4WHtl1QmyxkyyJxot_EiKh1Z5yFLRPd06mK9PD0Meta } from "/app/frontend/pages/parbaudes-darbi/index.vue?macro=true";
import { default as jaunsqps7hsdTou8wJnam5f9tQ9GbWOqjl_jy1kqAV08o824Meta } from "/app/frontend/pages/testu-redaktors/jauns.vue?macro=true";
import { default as pdfm3dbOCas6r2TR75ZcPlFFn51uvUUSp_45P1Z4Y8uHqwG8Meta } from "/app/frontend/pages/darba-lapas/[slug]/pdf.vue?macro=true";
import { default as index7Ej_45yEQ0sAyz2T4HWPqyq156LPd6Tl473Bg0tTZobjsMeta } from "/app/frontend/pages/rezultatu-analize/index.vue?macro=true";
import { default as indexNJGgZ2zzFchjag77fdXCmgINaghj1JLLaucLJu3XJtwMeta } from "/app/frontend/pages/testi-un-jautajumi/index.vue?macro=true";
import { default as _91quizId_93MBfmcN8Moz859xjaJ791C4nM2uKDpFI1FfmfXUQak2AMeta } from "/app/frontend/pages/testu-redaktors/[quizId].vue?macro=true";
import { default as indexMLPF_4MzPpbZGXeLyUJ8FmaKVq8d9EgcTqNRcqIs5t8Meta } from "/app/frontend/pages/metodiskie-lidzekli/index.vue?macro=true";
import { default as indexypQQszELcI_oFj2Qp1xag9kzzB65OY8KAZXCWzOVvO8Meta } from "/app/frontend/pages/video/[productSlug]/index.vue?macro=true";
import { default as pdfum68RdfAAwt_454KdtniU7nZujMVA_sQf_45mgdmHkd6s_cMeta } from "/app/frontend/pages/parbaudes-darbi/[slug]/pdf.vue?macro=true";
import { default as indexTtH_YpLqz_45gbWmQUzgUmn3MZhYSvJSD_454W4R8SaY9yoMeta } from "/app/frontend/pages/interaktivie-materiali/index.vue?macro=true";
import { default as edit73_DT3DkXJdxFo3GA6FBWMyBsWOVk5evHwqaucQehCgMeta } from "/app/frontend/pages/viedtema/[smartFileSlug]/edit.vue?macro=true";
import { default as indexxsKpHgX7bROvic5avm_45GadCWnXOPjKG3bo2hmOqYi9wMeta } from "/app/frontend/pages/viedtemas/[subjectSlug]/index.vue?macro=true";
import { default as index6fb13V2mGQJQjjPsc62KP7AE21eWv4Vf3Yyhniz0uosMeta } from "/app/frontend/pages/e-gramatas/[productSlug]/index.vue?macro=true";
import { default as pdfzo4mLYNezYuejpo_JGVjPwMjKhL3PiSJU1JVmsvtfXUMeta } from "/app/frontend/pages/metodiskie-lidzekli/[slug]/pdf.vue?macro=true";
import { default as index25TnrSWW6Ozrp0f3ZguyYVbvJtKTqVH_UnE_6GUOkrMMeta } from "/app/frontend/pages/viedtema/[smartFileSlug]/index.vue?macro=true";
import { default as indexGWuYf0EatCk41KcYvJWVlRaq_4542KK6l5B9sYes_45U_3MMeta } from "/app/frontend/pages/darba-lapas/[productSlug]/index.vue?macro=true";
import { default as froonttrc5sjlPDRojzX4xgsjIBdQ1XzIJ82zu7NzWrzDS2lYMeta } from "/app/frontend/pages/viedtema/[smartFileSlug]/froont.vue?macro=true";
import { default as ievadswmPKbRmThySDSjIGsB7YNtDVJxlZP_56HCzVo6vWpb0Meta } from "/app/frontend/pages/viedtema/[smartFileSlug]/ievads.vue?macro=true";
import { default as indexL28N5owEf2D5nGSGfVOSDbp4N3FmNPFp5ZkULA8zxKkMeta } from "/app/frontend/pages/parbaudes-darbi/[productSlug]/index.vue?macro=true";
import { default as indexjc_45In34kRZmwUkN6ebv6KWbcj3nxMn5WQ31k52MC6pcMeta } from "/app/frontend/pages/metodiskie-lidzekli/[productSlug]/index.vue?macro=true";
import { default as indexWUtN_45DF1kfpiqQNJE6m4qXkY0ZyNYBl9z6_45hpw_45xSSkMeta } from "/app/frontend/pages/interaktivie-materiali/[productSlug]/index.vue?macro=true";
import { default as editJEtYuILkzmII23UVxMSqBHCtHBrunTaLrwiqFx9gdnIMeta } from "/app/frontend/pages/viedtema/[subjectSlug]/[gradeSlug]/[sectionSlug]/[smartFileSlug]/edit.vue?macro=true";
import { default as indexc1KS3KEQc_45N20vR3WsvAu6MNMBCfPlU8ghSbJ3KYf_MMeta } from "/app/frontend/pages/viedtemas/[subjectSlug]/[gradeSlug]/[productSlug]/[sectionSlug]/index.vue?macro=true";
import { default as indexdDHSxoLqY5b9b0Xm5YJ7cwWWlOvH0Huv323BvqwHCA4Meta } from "/app/frontend/pages/viedtema/[subjectSlug]/[gradeSlug]/[sectionSlug]/[smartFileSlug]/index.vue?macro=true";
import { default as froonttCts9YuHVrRegfjHPDaCI92CQAYkWi91CPu0BMbd5J8Meta } from "/app/frontend/pages/viedtema/[subjectSlug]/[gradeSlug]/[sectionSlug]/[smartFileSlug]/froont.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/frontend/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/app/frontend/pages/search.vue")
  },
  {
    name: "stylebook",
    path: "/stylebook",
    component: () => import("/app/frontend/pages/stylebook.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(indexmHuH5Riwp7lAI_PgbM9Ib0Nw_45skoGpqYfcTpVHhbO58Meta || {}), ...{"middleware":["skip-login"]} },
    component: () => import("/app/frontend/pages/login/index.vue")
  },
  {
    name: "testi",
    path: "/testi",
    component: () => import("/app/frontend/pages/testi/index.vue")
  },
  {
    name: "video",
    path: "/video",
    component: () => import("/app/frontend/pages/video/index.vue")
  },
  {
    name: "viedgramata",
    path: "/viedgramata",
    component: () => import("/app/frontend/pages/viedgramata.vue")
  },
  {
    name: "mani-zurnali",
    path: "/mani-zurnali",
    meta: {"middleware":["my-journals-auth"]},
    component: () => import("/app/frontend/pages/mani-zurnali.vue")
  },
  {
    name: "parskats",
    path: "/parskats",
    component: () => import("/app/frontend/pages/parskats/index.vue")
  },
  {
    name: "viedtemas",
    path: "/viedtemas",
    component: () => import("/app/frontend/pages/viedtemas/index.vue")
  },
  {
    name: "e-gramatas",
    path: "/e-gramatas",
    component: () => import("/app/frontend/pages/e-gramatas/index.vue")
  },
  {
    name: "mani-testi",
    path: "/mani-testi",
    component: () => import("/app/frontend/pages/mani-testi/index.vue")
  },
  {
    name: "pirmsskola",
    path: "/pirmsskola",
    meta: indexZoWxXVdKGnwzJV8N07rA_uqXt7MnZjEWOfkJIpdKjY4Meta || {},
    component: () => import("/app/frontend/pages/pirmsskola/index.vue")
  },
  {
    name: "darba-lapas",
    path: "/darba-lapas",
    component: () => import("/app/frontend/pages/darba-lapas/index.vue")
  },
  {
    name: "link-code",
    path: "/link/:code()",
    component: () => import("/app/frontend/pages/link/[code]/index.vue")
  },
  {
    name: "pdf-reader-slug",
    path: "/pdf-reader/:slug()",
    meta: _91slug_93MMC5KbSdXEUgMCBA6NLRlk1s8ma7otM0UHqNgzLzUK4Meta || {},
    component: () => import("/app/frontend/pages/pdf-reader/[slug].vue")
  },
  {
    name: "somas-testi",
    path: "/somas-testi",
    component: () => import("/app/frontend/pages/somas-testi/index.vue")
  },
  {
    name: "visi-resursi",
    path: "/visi-resursi",
    component: () => import("/app/frontend/pages/visi-resursi/index.vue")
  },
  {
    name: "darba-lapas-parskats",
    path: "/darba-lapas/parskats",
    component: () => import("/app/frontend/pages/darba-lapas/parskats.vue")
  },
  {
    name: "e-gramatas-slug-pdf",
    path: "/e-gramatas/:slug()/pdf",
    meta: pdfT6RDHLLuxpV0O6ZyDT0IVxy_45iMCxyWAfsVvzAOLr1cwMeta || {},
    component: () => import("/app/frontend/pages/e-gramatas/[slug]/pdf.vue")
  },
  {
    name: "jautajumu-banka",
    path: "/jautajumu-banka",
    component: () => import("/app/frontend/pages/jautajumu-banka/index.vue")
  },
  {
    name: "parbaudes-darbi",
    path: "/parbaudes-darbi",
    meta: {"middleware":["has-test-works"]},
    component: () => import("/app/frontend/pages/parbaudes-darbi/index.vue")
  },
  {
    name: "testu-redaktors-jauns",
    path: "/testu-redaktors/jauns",
    meta: jaunsqps7hsdTou8wJnam5f9tQ9GbWOqjl_jy1kqAV08o824Meta || {},
    component: () => import("/app/frontend/pages/testu-redaktors/jauns.vue")
  },
  {
    name: "darba-lapas-slug-pdf",
    path: "/darba-lapas/:slug()/pdf",
    meta: pdfm3dbOCas6r2TR75ZcPlFFn51uvUUSp_45P1Z4Y8uHqwG8Meta || {},
    component: () => import("/app/frontend/pages/darba-lapas/[slug]/pdf.vue")
  },
  {
    name: "rezultatu-analize",
    path: "/rezultatu-analize",
    component: () => import("/app/frontend/pages/rezultatu-analize/index.vue")
  },
  {
    name: "testi-un-jautajumi",
    path: "/testi-un-jautajumi",
    component: () => import("/app/frontend/pages/testi-un-jautajumi/index.vue")
  },
  {
    name: "testu-redaktors-quizId",
    path: "/testu-redaktors/:quizId()",
    meta: _91quizId_93MBfmcN8Moz859xjaJ791C4nM2uKDpFI1FfmfXUQak2AMeta || {},
    component: () => import("/app/frontend/pages/testu-redaktors/[quizId].vue")
  },
  {
    name: "metodiskie-lidzekli",
    path: "/metodiskie-lidzekli",
    component: () => import("/app/frontend/pages/metodiskie-lidzekli/index.vue")
  },
  {
    name: "video-productSlug",
    path: "/video/:productSlug()",
    component: () => import("/app/frontend/pages/video/[productSlug]/index.vue")
  },
  {
    name: "parbaudes-darbi-slug-pdf",
    path: "/parbaudes-darbi/:slug()/pdf",
    meta: pdfum68RdfAAwt_454KdtniU7nZujMVA_sQf_45mgdmHkd6s_cMeta || {},
    component: () => import("/app/frontend/pages/parbaudes-darbi/[slug]/pdf.vue")
  },
  {
    name: "interaktivie-materiali",
    path: "/interaktivie-materiali",
    component: () => import("/app/frontend/pages/interaktivie-materiali/index.vue")
  },
  {
    name: "viedtema-smartFileSlug-edit",
    path: "/viedtema/:smartFileSlug()/edit",
    meta: edit73_DT3DkXJdxFo3GA6FBWMyBsWOVk5evHwqaucQehCgMeta || {},
    component: () => import("/app/frontend/pages/viedtema/[smartFileSlug]/edit.vue")
  },
  {
    name: "viedtemas-subjectSlug",
    path: "/viedtemas/:subjectSlug()",
    component: () => import("/app/frontend/pages/viedtemas/[subjectSlug]/index.vue")
  },
  {
    name: "e-gramatas-productSlug",
    path: "/e-gramatas/:productSlug()",
    component: () => import("/app/frontend/pages/e-gramatas/[productSlug]/index.vue")
  },
  {
    name: "metodiskie-lidzekli-slug-pdf",
    path: "/metodiskie-lidzekli/:slug()/pdf",
    meta: pdfzo4mLYNezYuejpo_JGVjPwMjKhL3PiSJU1JVmsvtfXUMeta || {},
    component: () => import("/app/frontend/pages/metodiskie-lidzekli/[slug]/pdf.vue")
  },
  {
    name: "viedtema-smartFileSlug",
    path: "/viedtema/:smartFileSlug()",
    component: () => import("/app/frontend/pages/viedtema/[smartFileSlug]/index.vue")
  },
  {
    name: "darba-lapas-productSlug",
    path: "/darba-lapas/:productSlug()",
    component: () => import("/app/frontend/pages/darba-lapas/[productSlug]/index.vue")
  },
  {
    name: "viedtema-smartFileSlug-froont",
    path: "/viedtema/:smartFileSlug()/froont",
    component: () => import("/app/frontend/pages/viedtema/[smartFileSlug]/froont.vue")
  },
  {
    name: "viedtema-smartFileSlug-ievads",
    path: "/viedtema/:smartFileSlug()/ievads",
    meta: ievadswmPKbRmThySDSjIGsB7YNtDVJxlZP_56HCzVo6vWpb0Meta || {},
    component: () => import("/app/frontend/pages/viedtema/[smartFileSlug]/ievads.vue")
  },
  {
    name: "parbaudes-darbi-productSlug",
    path: "/parbaudes-darbi/:productSlug()",
    component: () => import("/app/frontend/pages/parbaudes-darbi/[productSlug]/index.vue")
  },
  {
    name: "metodiskie-lidzekli-productSlug",
    path: "/metodiskie-lidzekli/:productSlug()",
    component: () => import("/app/frontend/pages/metodiskie-lidzekli/[productSlug]/index.vue")
  },
  {
    name: "interaktivie-materiali-productSlug",
    path: "/interaktivie-materiali/:productSlug()",
    component: () => import("/app/frontend/pages/interaktivie-materiali/[productSlug]/index.vue")
  },
  {
    name: "viedtema-subjectSlug-gradeSlug-sectionSlug-smartFileSlug-edit",
    path: "/viedtema/:subjectSlug()/:gradeSlug()/:sectionSlug()/:smartFileSlug()/edit",
    meta: editJEtYuILkzmII23UVxMSqBHCtHBrunTaLrwiqFx9gdnIMeta || {},
    component: () => import("/app/frontend/pages/viedtema/[subjectSlug]/[gradeSlug]/[sectionSlug]/[smartFileSlug]/edit.vue")
  },
  {
    name: "viedtemas-subjectSlug-gradeSlug-productSlug-sectionSlug",
    path: "/viedtemas/:subjectSlug()/:gradeSlug()/:productSlug()/:sectionSlug()",
    component: () => import("/app/frontend/pages/viedtemas/[subjectSlug]/[gradeSlug]/[productSlug]/[sectionSlug]/index.vue")
  },
  {
    name: "viedtema-subjectSlug-gradeSlug-sectionSlug-smartFileSlug",
    path: "/viedtema/:subjectSlug()/:gradeSlug()/:sectionSlug()/:smartFileSlug()",
    component: () => import("/app/frontend/pages/viedtema/[subjectSlug]/[gradeSlug]/[sectionSlug]/[smartFileSlug]/index.vue")
  },
  {
    name: "viedtema-subjectSlug-gradeSlug-sectionSlug-smartFileSlug-froont",
    path: "/viedtema/:subjectSlug()/:gradeSlug()/:sectionSlug()/:smartFileSlug()/froont",
    component: () => import("/app/frontend/pages/viedtema/[subjectSlug]/[gradeSlug]/[sectionSlug]/[smartFileSlug]/froont.vue")
  }
]